import { PROJECTS_URL, UPLOADS_URL } from '../constans';
import { apiSlice } from './apiSlice';

const projectsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProjects2: builder.query({
      query: (data) => ({
        url: `${PROJECTS_URL}/v2/`,
        params: {
          ...data
        }
      }),
      keepUnusedDataFor: 0,
    }),
    getProjectField: builder.query({
      query: (data) => ({
        url: `${PROJECTS_URL}/v2/${data?.projectId}/field/${data?.name}`
      }),
      keepUnusedDataFor: 0,
    }),
    getProjects: builder.query({
      query: (data) => ({
        url: PROJECTS_URL,
        params: {
          viewInvisible: data?.viewInvisible
        }
      }),
      keepUnusedDataFor: 0,
    }),
    getProjectById: builder.query({
      query: (projectId, data) => ({
        url: `${PROJECTS_URL}/${projectId}`,
      }),
      keepUnusedDataFor: 5,
    }),
    getProjectById2: builder.query({
      query: (projectId, data) => ({
        url: `${PROJECTS_URL}/v2/${projectId}`,
      }),
      keepUnusedDataFor: 5,

    }),
    getProjectByIdToEdit: builder.query({
      query: (projectId, data) => ({
        url: `${PROJECTS_URL}/edit/${projectId}`,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Project'],
    }),
    getFunnelCorrectionPreview: builder.query({
      query: ({ projectId, toType }) => ({
        url: `${PROJECTS_URL}/v2/${projectId}/funnel-correction`,
        params: toType ? { toType } : {},
      }),
      providesTags: ['Project'],
    }),
    applyFunnelCorrection: builder.mutation({
      query: ({ projectId, ...body }) => ({
        url: `${PROJECTS_URL}/v2/${projectId}/funnel-correction`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Project'],
    }),
    // getProjectByIdToEdit2: builder.query({
    //   query: (projectId, data) => ({
    //     url: `${PROJECTS_URL}/v2/edit/${projectId}`,
    //   }),
    //   keepUnusedDataFor: 5,
    // }),
    createUpdateProject: builder.mutation({
      query: (data) => ({
        url: `${PROJECTS_URL}`,
        method: 'POST',
        body: data,
      }),
      // keepUnusedDataFor: 5,
      invalidatesTags: ['Project'],
    }),
    putComments: builder.mutation({
      query: (data) => ({
        url: `${PROJECTS_URL}/v2/putComments`,
        method: 'POST',
        body: data,
      }),
      keepUnusedDataFor: 5,
    }),
    createUpdateProject2: builder.mutation({
      query: (data) => ({
        url: `${PROJECTS_URL}/v2/`,
        method: 'POST',
        body: data,
      }),
      // keepUnusedDataFor: 5,
      invalidatesTags: ['Project'],
    }),

    uploadProjectImage: builder.mutation({
      query: (data) => ({
        url: `${UPLOADS_URL}`,
        method: 'POST',
        body: data,
      }),
    }),

    addProjectImage: builder.mutation({
      query: (data) => ({
        url: `${PROJECTS_URL}/v2/${data.projectId}/image`,
        method: 'POST',
        body: data,
      }),
    }),
    addProjectDocument: builder.mutation({
      query: (data) => ({
        url: `${PROJECTS_URL}/v2/${data.projectId}/documents`,
        method: 'POST',
        body: data,
      }),
    }),
    hideProjectDocument: builder.mutation({
      query: ({ projectId, documentId }) => ({
        // Передаем documentId прямо в URL
        url: `${PROJECTS_URL}/v2/${projectId}/documents/${documentId}`,
        method: 'PATCH',
      }),
    }),
    deleteProjectImage: builder.mutation({
      query: (data) => ({
        url: `${PROJECTS_URL}/image/`,
        method: 'DELETE',
        body: data,
      }),
    }),
    deleteProject: builder.mutation({
      query: (data) => ({
        url: `${PROJECTS_URL}/${data.id}`,
        method: 'DELETE',
        body: data,
      }),
    }),
  }),
});

export const {
  usePutCommentsMutation,
  useGetProjectFieldQuery,
  useGetProjectById2Query,
  useGetProjects2Query,
  useGetProjectsQuery,
  useGetProjectByIdQuery,
  useGetProjectByIdToEditQuery,
  useGetFunnelCorrectionPreviewQuery,
  useApplyFunnelCorrectionMutation,
  useCreateUpdateProjectMutation,
  useCreateUpdateProject2Mutation,
  useUploadProjectImageMutation,
  useAddProjectImageMutation,
  useAddProjectDocumentMutation,
  useDeleteProjectImageMutation,
  useDeleteProjectMutation,
  useHideProjectDocumentMutation,
} = projectsApiSlice;
